export const DS_TOOLTIP_ATTRIBUTES = {
  Text: "data-ds-tooltip",
  Title: "data-ds-tooltip-title",
  KeyboardShortcut: "data-ds-tooltip-kbd",
  KeyboardShortcutMac: "data-ds-tooltip-kbd-mac",
  Placement: "data-ds-tooltip-placement",
  RequestedPlacement: "data-ds-tooltip-requested-placement",
  ResolvedPlacement: "data-ds-tooltip-resolved-placement",
} as const;

export const DS_TOOLTIP_SELECTOR = `[${DS_TOOLTIP_ATTRIBUTES.Text}]`;
export const DS_TOOLTIP_ID = "ds-tooltip";
export const DS_TOOLTIP_ANCHOR_NAME = "--ds-tooltip-anchor";
